import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { container } from "tsyringe";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import I18n from "components/materials/I18n";
import PageTemplate from "components/PageTemplate";
import ModuleConfig from "configs/ModuleConfig";
import { useCommentId } from "hooks/useCommentId";
import { usePostId } from "hooks/usePostId";
import { useProjectId } from "hooks/useProjectId";
import CommentService from "services/projects/CommentService";
import CommentCard from "../ForumPost/components/CommentSection/CommentCard";
import ReturnButton from "../ForumPost/components/ReturnButton";
import { ProjectProvider } from "../FeaturedProjects/contexts/Project";
import classes from "./classes.module.scss";

const commentService = container.resolve(CommentService);
const modules = container.resolve(ModuleConfig).get().modules;

export default function ForumPostComment() {
	const { comment } = useComment();
	const { redirectToPost } = usePostNavigation();

	return (
		comment && (
			<ProjectProvider>
				<PageTemplate tabTitle={I18n.trslt(I18n.asset.pages.post.title)}>
					<div className={classes["root"]}>
						<ReturnButton />
						<CommentCard key={comment.id} comment={comment} depth={0} onDeleted={redirectToPost} />
					</div>
				</PageTemplate>
			</ProjectProvider>
		)
	);
}

const useComment = () => {
	const { projectId } = useProjectId();
	const { postId } = usePostId();
	const { commentId } = useCommentId();
	const [comment, setComment] = useState<CommentResponseResource | null>(null);

	const fetchComment = useCallback(async () => {
		commentService.getById(projectId, postId, commentId).then(setComment);
	}, [commentId, postId, projectId]);

	useEffect(() => {
		fetchComment();
	}, [fetchComment]);

	return { comment };
};

const usePostNavigation = () => {
	const { projectId } = useProjectId();
	const { postId } = usePostId();
	const navigate = useNavigate();

	const redirectToPost = useCallback(() => {
		navigate(modules.pages.ForumPost.props.path.replace(":projectId", projectId).replace(":postId", postId));
	}, [navigate, postId, projectId]);

	return { redirectToPost };
};
